import { getWebApp, isInTelegram, tgVersionAtLeast } from '../telegram'

function nameFromUrl(absolute: string): string {
  try {
    const last = decodeURIComponent(new URL(absolute).pathname.split('/').pop() ?? '')
    return /\.[a-z0-9]{2,5}$/i.test(last) ? last : 'video.mp4'
  } catch {
    return 'video.mp4'
  }
}

/** В Mini App файл сохраняется родным окном Telegram (8.0+); раньше — только через браузер. */
export function canSaveInTelegram(): boolean {
  return tgVersionAtLeast('8.0') && typeof getWebApp()?.downloadFile === 'function'
}

/**
 * Скачать файл по подписанной ссылке. Сервер отдаёт такие ссылки с
 * Content-Disposition: attachment. В Mini App 8.0+ — родное окно Telegram
 * «Скачать файл» (`downloadFile`), в старых клиентах ссылка открывается в
 * браузере телефона. В Mini App с ботом главное действие — «Отправить в чат».
 */
export function downloadFile(url: string, fileName?: string): void {
  const absolute = new URL(url, window.location.origin).href
  const tg = getWebApp()
  if (tg && isInTelegram()) {
    if (canSaveInTelegram()) {
      try {
        tg.downloadFile?.({ url: absolute, file_name: fileName || nameFromUrl(absolute) })
        return
      } catch {
      }
    }
    tg.openLink(absolute)
    return
  }
  const a = document.createElement('a')
  a.href = absolute
  a.download = fileName ?? ''
  document.body.appendChild(a)
  a.click()
  a.remove()
}

/** Внешняя ссылка: в Mini App — через Telegram, иначе новая вкладка. */
export function openExternal(url: string): void {
  const tg = getWebApp()
  if (tg && isInTelegram()) {
    if (url.startsWith('https://t.me/')) tg.openTelegramLink(url)
    else tg.openLink(url)
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}

/** «Поделиться» ссылкой через Telegram: выбор чата и готовое сообщение. */
export function shareToTelegram(url: string, text?: string): void {
  // encodeURIComponent, а не URLSearchParams: пробел должен стать %20, а не «+».
  const tail = text ? `&text=${encodeURIComponent(text)}` : ''
  openExternal(`https://t.me/share/url?url=${encodeURIComponent(url)}${tail}`)
}
